import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  errors,
  IStyledAttributes,
  Log,
  NO_VALUE_DISPLAY,
  RideStatusEnum,
  useIsMobile,
} from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

import {
  FramerTooltip,
  IRideStatusIndicator,
  IRideStatusIndicatorControl,
  RideStatusIndicatorConst,
} from "../../common";

const RideStatusCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "ride-status-cell",
})<IRideStatusIndicatorControl>`
  width: 110px;
  height: 24px;
  background-color: ${props => props.$bgColor};
  border-inline-start: 2px solid ${props => props.$leftColor};
  color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  border-radius: 3px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 35px;
  }
`;

export const RideStatusCell: FC<IRideStatusIndicator> = ({ status }) => {
  const info = RideStatusIndicatorConst[status || RideStatusEnum.New];

  const { t } = useTranslation();

  if (!info) {
    Log.warn(t(errors.ride.invalidRideStatus), status);
  }

  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    if (!status || !info?.$translateKey) {
      return NO_VALUE_DISPLAY;
    }

    const text = translateLabel(info.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info?.$translateKey, isMobile, status, translateLabel]);
  return (
    <FramerTooltip
      content={t("ride.RIDE_STATUS_TOOLTIP", { status: statusText })}
    >
      <RideStatusCellStyled {...info}>{statusText}</RideStatusCellStyled>
    </FramerTooltip>
  );
};
